export default "I er låst inde i en fængselscelle. I har 60 minutter til at undslippe, mens vagten er væk.";